import { render, staticRenderFns } from "./flowData.vue?vue&type=template&id=b7ccebb6&scoped=true&"
import script from "./flowData.vue?vue&type=script&lang=js&"
export * from "./flowData.vue?vue&type=script&lang=js&"
import style0 from "./flowData.vue?vue&type=style&index=0&id=b7ccebb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ccebb6",
  null
  
)

export default component.exports